<template>
  <NFormItem v-if="!outOfTime" class="text-center" v-bind="formItemBaseAttrs">
    <span class="n-ntimer-remaining">({{ remainingTime }}s)</span>
  </NFormItem>
  <div class="n-form-item" v-else>
    <NButton type="text" size="small" class="extra-btn mt-[3px]" @click="resend">
      <template #icon><reload-outlined /></template>
      <span class="!text-xs n-ntimer-resend">{{ $tl('resend') }}</span>
    </NButton>
  </div>
</template>

<script setup>
import {computed, onMounted, ref, useAttrs, watch} from 'vue';
import {useFormItemBaseAttrs} from './hooks/useFormItemBaseAttrs';
import {NButton} from "@/components";

const attrs = useAttrs();

const props = defineProps({
  label: String,
  name: [String, Array],
  customLabel: String,
  seconds: { type: Number, default: 60 },
  resendSuccess: { type: Boolean, default: false },
});

const { formItemBaseAttrs, componentBaseAttrs } = useFormItemBaseAttrs(props);

const componentAttrs = computed(() => ({
  ...componentBaseAttrs.value,
  ...attrs,
}));

const emits = defineEmits(['onResend', 'reSchedule']);
const remainingTime = computed(() => props.seconds);
const outOfTime = computed(() => props.seconds <= 0);

async function resend(){
  emits('onResend');
}

</script>

<script>
export default {
  name: 'NTimer',
  inheritAttrs: false,
};
</script>

<style lang="less">
.n-ntimer-remaining {
  color: #777777;
}
.n-ntimer-resend {
  color: #0e0ef1;
}
</style>